import React from "react";
import { InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { CustomSearchTextField } from "../../../../../Components/CustomMuiComponents";
import { AreaContext } from "../Context/AreaContext";

export default function SearchAreas() {
  const { filter, setFilter } = React.useContext(AreaContext);
  return (
    <CustomSearchTextField
      placeholder="Buscar"
      size="small"
      variant="outlined"
      value={filter}
      onChange={(e) => setFilter(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );
}
